<template>
    <div class="vertical-container vertical-container--in-secondary-content">
        <div class="vertical-container__header vertical-container__header--has-shadow">
            <div class="container">
                <div class="section-header">
                    <div class="section-header__title">
                        <h1>Budovy</h1>
                    </div>

                    <div class="section-header__button">
                        <custom-button @click="create" primaryadd>
                            <span icon>&plus;</span>
                            <span class="section-header__button-label">Založit novou budovu</span>
                        </custom-button>
                    </div>
                </div>
            </div>
        </div>

        <div class="vertical-container__content">
            <building-container/>
        </div>
    </div>
</template>
<script>
import BuildingContainer from '../components/Building/BuildingContainer';
import CreateBuildingDialog
    from '@/modules/ProjectModule/modules/OptionModule/components/Building/CreateBuildingDialog';
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    components: {CustomButton, BuildingContainer },
    methods:    {
        create() {
            this.$modal.show(CreateBuildingDialog, {}, defaultModalParameters());
        }
    }
}
</script>
